import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { createContext, useContext, useState } from "react";
import { Toaster } from "sonner";
import MarketingPage from "@/pages/MarketingPage";
import Login from "@/pages/Login";
import PmsHome from "@/pages/PmsHome";
import PropertySetup from "@/pages/PropertySetup";
import ChannelWizard from "@/pages/ChannelWizard";
import { TeamLogin, TeamInviteAccept, TeamForgot, TeamReset } from "@/pages/TeamAuth";
import LaunchPms from "@/pages/LaunchPms";
import PmsWorkspace from "@/pages/PmsWorkspace";
import PublicGallery from "@/pages/PublicGallery";
import SelfCheckin from "@/pages/SelfCheckin";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const Protected = ({ children }) => {
  const { token } = useAuth();
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  const [token, setToken] = useState(localStorage.getItem("atiti_token"));
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("atiti_user")); } catch { return null; }
  });

  const login = (tok, usr) => {
    localStorage.setItem("atiti_token", tok);
    localStorage.setItem("atiti_user", JSON.stringify(usr));
    setToken(tok); setUser(usr);
  };
  const logout = () => {
    localStorage.removeItem("atiti_token");
    localStorage.removeItem("atiti_user");
    setToken(null); setUser(null);
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MarketingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/host" element={<Navigate to="/pms" replace />} />
          <Route path="/pms" element={<Protected><PmsHome /></Protected>} />
          <Route path="/pms/launch" element={<Protected><LaunchPms /></Protected>} />
          <Route path="/pms/app" element={<Protected><PmsWorkspace /></Protected>} />
          <Route path="/pms/property/:pid" element={<Protected><PropertySetup /></Protected>} />
          <Route path="/pms/property/:pid/channels" element={<Protected><ChannelWizard /></Protected>} />
          <Route path="/team-login" element={<TeamLogin />} />
          <Route path="/team-invite/:token" element={<TeamInviteAccept />} />
          <Route path="/team-forgot" element={<TeamForgot />} />
          <Route path="/team-reset/:token" element={<TeamReset />} />
          <Route path="/gallery/:pid" element={<PublicGallery />} />
          <Route path="/checkin/:pid/:token" element={<SelfCheckin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthContext.Provider>
  );
}

export default App;
